import React from "react";
import { Modal, Form, Input } from "antd";
import fetchHandler from "@/fetch/fetchHandler";
import { updateFirmwareRemark } from "@/fetch/fetchApi";

class RemarkModal extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  // 设置Form的ref
  formRef = React.createRef();

  handleSubmit = () => {
    const { validateFields } = this.formRef.current;

    validateFields()
      .then((values) => {
        // console.log(values);
        fetchHandler(updateFirmwareRemark, {
          frameType: this.props.record.frameType,
          ...values,
        }).then((res) => {
          if (res && res.code === "success") {
            this.props.refresh();
            this.props.onCancel();
          }
        });
      })
      .catch(() => {
        // console.log(values);
      });
  };

  render() {
    return (
      <Modal title="备注" visible onCancel={this.props.onCancel} onOk={this.handleSubmit}>
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 16 }} ref={this.formRef}>
          <Form.Item
            label="备注"
            initialValue={this.props.record.info}
            name="info"
            style={{ overflow: "inherit" }}
            rules={[{ required: true, message: "请输入备注" }]}>
            <Input.TextArea placeholder="请输入"></Input.TextArea>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default RemarkModal;



// WEBPACK FOOTER //
// ./src/AntD/pages/system/firmwareVersionManage/remarkModal.js